import { object, number, array, mixed } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { getRewardValueValidationSchema } from '@shared/utils';

import { UserRewardType } from 'v2/constants';

export const vipWheelSettingsSchema = object().shape({
  spinResetHours: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  defaultSpinsNumber: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  defaultRewardsMap: array().of(
    object().shape({
      type: mixed().oneOf(Object.values(UserRewardType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
      value: getRewardValueValidationSchema(),
    })
  ),
  diamondSpinsNumber: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  diamondRewardsMap: array().of(
    object().shape({
      type: mixed().oneOf(Object.values(UserRewardType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
      value: getRewardValueValidationSchema(),
    })
  ),
  eliteSpinsNumber: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  eliteRewardsMap: array().of(
    object().shape({
      type: mixed().oneOf(Object.values(UserRewardType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
      value: getRewardValueValidationSchema(),
    })
  ),
});
